import script from "./VEmpty.vue?vue&type=script&lang=js"
export * from "./VEmpty.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__